import React, { useState, useEffect } from 'react'
import { Row, Col, Checkbox, Input, Button, Select, Badge, TimePicker, notification } from 'antd'
import { UserOutlined } from "@ant-design/icons";
import moment from 'moment';
import RequestHandler from "util/RequestHandler";
import CurrencyInput from 'react-currency-input';
const format = 'HH:mm';

const NotificationUpdate = (props) => {
  const [loading, setLoading] = useState(false);
  const [time, setTime] = useState(props.data.time);
  const [mail, setMail] = useState(props.data.mail);
  const [id, setId] = useState(props.data.id);
  const [upMoney, setUpMoney] = useState(props.data.upMoney);
  const [downMoney, setDownMoney] = useState(props.data.downMoney);
  const [accountBalance, setAccountBalance] = useState(props.data.accountBalance);
  const [balance, setBalance] = useState(props.data.balance);
  const [consolidated, setConsolidated] = useState(props.data.consolidated);
  const [moneyInflow, setMoneyInflow] = useState(props.data.moneyInflow);
  const [moneyOut, setMoneyOut] = useState(props.data.moneyOut);
  const [isFullTenantAccount, setIsFullTenantAccount] = useState(props.data.isFullTenantAccount);
  const [isFullTransactionType, setIsFullTransactionType] = useState(props.data.isFullTransactionType);
  const [erpTemplateSelect, setErpTemplateSelect] = useState({
    data: [],
    loading: false,
  });
  const [isMonthlyErpNotification, setIsMonthlyErpNotification] = useState(props.data.isMonthlyErpNotification);
  const [erpTemplate, setErpTemplate] = useState(props.data.notificationErpTemplateId);
  const [isPosCommissionNotification, setIsPosCommissionNotification] = useState(props.data.isPosCommissionNotification);

  useEffect(() => {
    setId(props.data.id);
    props.data.time === "" ? setTime("00:00") : setTime(props.data.time);
    setUpMoney(props.data.upMoney);
    setDownMoney(props.data.downMoney);
    setMail(props.data.mail);
    setBalance(props.data.balance);
    setAccountBalance(props.data.accountBalance);
    setConsolidated(props.data.consolidated);
    setMoneyInflow(props.data.moneyInflow);
    setMoneyOut(props.data.moneyOut);
    setIsFullTenantAccount(props.data.isFullTenantAccount);
    setIsFullTransactionType(props.data.isFullTransactionType);
    setIsMonthlyErpNotification(props.data.isMonthlyErpNotification);
    setErpTemplate(props.data.notificationErpTemplateId);
    setIsPosCommissionNotification(props.data.isPosCommissionNotification);
  }, [
    props.data.upMoney,
    props.data.downMoney,
    props.data.id,
    props.data.mail,
    props.data.time,
    props.data.accountBalance,
    props.data.balance,
    props.data.consolidated,
    props.data.moneyInflow,
    props.data.moneyOut,
    props.data.isMonthlyErpNotification,
    props.data.notificationErpTemplateId,
    props.data.isPosCommissionNotification,
  ]);

  useEffect(() => {
    getErpTemplates();
  }, []);

  const getErpTemplates = () => {
    setErpTemplateSelect({
      ...erpTemplateSelect,
      loading: true,
    });
    RequestHandler.get(`/Notification/GetErpTemplates?$select=id,name`).then((response) => {
      setErpTemplateSelect({
        data: response,
        loading: false,
      });
    }
    );
  };

  const onChangeUpMoney = (e) => {
    setUpMoney(e)
  };
  const onChangeDownMoney = (e) => {
    setDownMoney(e)
  };

  const setSubmit = () => {
    if ((time === "") && (balance || accountBalance || consolidated)) {
      timeError("warning");
      return;
    }
    setLoading(true);
    RequestHandler.put("/Notification", {
      Id: id,
      UpMoney: upMoney,
      DownMoney: downMoney,
      Mail: mail,
      Time: balance === true ? time : (consolidated === true ? time : (accountBalance === true ? time : "")),
      Balance: balance,
      AccountBalance: accountBalance,
      MoneyInflow: moneyInflow,
      MoneyOut: moneyOut,
      Consolidated: consolidated,
      isMonthlyErpNotification: isMonthlyErpNotification,
      IsFullTenantAccount: isFullTenantAccount,
      IsFullTransactionType: isFullTransactionType,
      notificationErpTemplateId: isMonthlyErpNotification ? erpTemplate : null,
      isPosCommissionNotification: isPosCommissionNotification,
    }).then((response) => {
      if (response.statusCode === 200 || response.statusCode === 204) {
        setTimeout(function () {
          props.sendDataForUpdate("success");
          setLoading(false);
        }.bind(this), 2000);
      } else {
        setLoading(false);
      }
    }).catch(function (error) {
      setLoading(false);
    });
  };
  const timeError = type => {
    notification[type]({
      message: 'Uyarı',
      description:
        'Lütfen saati tam veya buçuk olacak şekilde seçiniz.',
    });
  };
  const onChangeTime = time => {
    if (moment(time?.toString()).format('LT').split(':')[1] !== "00" && moment(time?.toString()).format('LT').split(':')[1] !== "30") {
      if (time !== null) {
        timeError("warning");
      }
      return;
    }
    if (time != null) {
      setTime(moment(time?.toString()).format('LT'));
    }
  };
  const onChangeMail = (e) => {
    setMail(e.target.value);
  };
  const onChangeBalance = (e) => {
    setBalance(!balance);
  };
  const onChangeAccountBalance = (e) => {
    setAccountBalance(!accountBalance);
  };
  const onChangeConsolidated = (e) => {
    setConsolidated(!consolidated);
  };
  const onChangeMoneyInFlow = (e) => {
    setMoneyInflow(!moneyInflow);
  };
  const onChangeMoneyOut = (e) => {
    setMoneyOut(!moneyOut);
  };
  return (
    <>
      <Row >
        <Col md={12} xs={24}>
          <Checkbox value="balance" checked={balance} onClick={onChangeBalance} >Banka Bakiyelerinin mail ile gönderilmesi </Checkbox>
        </Col>

        <Col md={12} xs={24}>
          <Checkbox value="accountBalance" checked={accountBalance} onClick={onChangeAccountBalance}>Banka Hesap Bakiyelerinin mail ile gönderilmesi </Checkbox>
        </Col>

        <Col md={12} xs={24}>
          <Checkbox value="consolidated" checked={consolidated} onClick={onChangeConsolidated}>Konsolide </Checkbox>
        </Col>

        <Col md={12} xs={24}>
          <Checkbox value="moneyInflow" checked={moneyInflow} onClick={onChangeMoneyInFlow}>Hesaplara para girişinde bilgi verilmesi</Checkbox>
        </Col>

        <Col md={12} xs={24}>
          <Checkbox value="moneyOut" checked={moneyOut} onClick={onChangeMoneyOut}>Hesaplardan para çıkışında bilgi verilmesi</Checkbox>
        </Col>

        <Col md={12} xs={24}>
          <Checkbox value="isMonthlyErpNotification" checked={isMonthlyErpNotification} onClick={() => setIsMonthlyErpNotification(!isMonthlyErpNotification)}>Aylık muhasebe bildirimi</Checkbox>
        </Col>

        <Col md={12} xs={24}>
          <Checkbox value="isPosCommissionNotification" checked={isPosCommissionNotification} onClick={() => setIsPosCommissionNotification(!isPosCommissionNotification)}>Aylık pos komisyon aşımı bildirimi</Checkbox>
        </Col>

      </Row>

      <Row style={{ marginTop: '4%' }} justify="center">

        <Col xs={24} md={12}>

          <Row>
            <Col span={24} className="gx-mb-2">
              {isMonthlyErpNotification && (
                <Select
                  allowClear
                  showSearch
                  placeholder="Varsayılan Muhasebe Şablonu"
                  filterOption={(input, option) => option.children
                    .toLocaleLowerCase("tr-TR")
                    .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                  }
                  loading={erpTemplateSelect.loading}
                  style={{ width: "100%" }}
                  value={erpTemplate}
                  onChange={(value) => setErpTemplate(value)}
                >
                  {erpTemplateSelect.data.map((item) => (
                    <Select.Option key={item.id} value={item.id}>
                      {item.name}
                    </Select.Option>
                  ))}
                </Select>
              )}
            </Col>

            <Col span={24} className="gx-mb-2">
              <Input placeholder="E-mail Adresi" value={mail} onChange={onChangeMail} prefix={<UserOutlined />} />
            </Col>

            <Col span={12} className="gx-mb-2">
              <Badge count={"Min"} style={{ backgroundColor: 'gray' }}>
                <CurrencyInput className="ant-input" style={{ width: "100%" }}
                  disabled={!(moneyInflow || moneyOut)}
                  placeholder="Tutardan fazlası" value={upMoney} onChange={onChangeUpMoney}
                  decimalSeparator="," thousandSeparator="." />
              </Badge>
            </Col>
            <Col span={12} className="gx-mb-2">
              <Badge count={"Max"} style={{ backgroundColor: 'gray' }}>
                <CurrencyInput className="ant-input" style={{ width: "100%" }}
                  disabled={!(moneyInflow || moneyOut)}
                  placeholder="Tutardan fazlası" value={downMoney} onChange={onChangeDownMoney}
                  decimalSeparator="," thousandSeparator="." />
              </Badge>
            </Col>
            <Col span={12} className="gx-mb-2">
              <TimePicker
                style={{ width: "100%" }}
                disabled={!(consolidated || balance || accountBalance)}
                placeholder={"Saat Seçin"} minuteStep={30} value={moment(time, format)} format={format} onChange={onChangeTime} />
            </Col>

            <Col span={24} className="gx-mb-2 gx-text-right">
              <Button type="primary" loading={loading} onClick={() => setSubmit()}>
                Güncelle
              </Button>
            </Col>
          </Row>

        </Col>

      </Row>

    </>
  )
}
export default NotificationUpdate;